import { InvestmentDetailsCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsCard/InvestmentDetailsCard.tsx';
import { CardBodySkeleton } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsCard/CardBodySkeleton.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Flex, Text } from '@mantine/core';
import { InvestmentDetailsRowItem } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsSidebar/components/InvestmentDetailsRowItem/InvestmentDetailsRowItem.tsx';
import { GetInvestmentDetailsOtherDataRes } from '@dealstack/shared/lib/generated';
import { ManageRequirementsButton } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsCard/ManageRequirementsButton.tsx';

interface Props {
	data: GetInvestmentDetailsOtherDataRes | undefined;
	onManageRequirements: () => void;
	canMutate: boolean;
}

export const InvestmentOtherData = ({ data, onManageRequirements, canMutate }: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<InvestmentDetailsCard
			cardLabel={tMipManage('investment_other_data.card_label')}
			actions={
				<ManageRequirementsButton canMutate={canMutate} onClick={onManageRequirements}>
					{tMipManage('investment_kyc_status.button.manage_requirements')}
				</ManageRequirementsButton>
			}
		>
			{data ? (
				<Flex direction="column" p="0.5rem">
					{data.otherData.map(({ id, label, value }, index) => (
						<InvestmentDetailsRowItem
							key={id}
							label={<Text c="dark.0">{label}</Text>}
							content={
								<Text fw={600} c="dark.8">
									{value}
								</Text>
							}
							hideBorder={index === 0}
						/>
					))}
				</Flex>
			) : (
				<CardBodySkeleton count={3} mih={120} />
			)}
		</InvestmentDetailsCard>
	);
};
